import { ClientesRoutes, OrdenesRoutes, ArticuloRoutes, GetResponseBody, GetHeaderRequest } from '../../config.jsx';
import axios from 'axios';

export const ClientesRequest = {
    ObtenerDatosClientes: async (pToken, pEmp_id, pSuc_id, pFecha1, pFecha2, pUsuario_Id) => {
        const data = { pToken, pEmp_id, pSuc_id, pFecha1, pFecha2, pUsuario_Id }
        const result = await axios.post(ClientesRoutes.ObtenerDatosClientes, JSON.stringify(data), { headers: GetHeaderRequest(pToken) });
        return await GetResponseBody(result);
    },
}

export const OrdenesRequest = {
    ObtenerDatosOrdenes: async (pToken, pEmp_id, pSuc_id, pFecha1, pFecha2, pTopN) => {
        const data = { pToken, pEmp_id, pSuc_id, pFecha1, pFecha2, pTopN }
        const result = await axios.post(OrdenesRoutes.ObtenerDatosOrdenes, JSON.stringify(data), { headers: GetHeaderRequest(pToken) });
        return await GetResponseBody(result);
    },
}


export const ArticulosRequest = {
    ObtenerDatosArticulos: async (pToken, pEmp_id, pSuc_id, pFecha1, pFecha2, pTopN) => {
        const data = { pToken, pEmp_id, pSuc_id, pFecha1, pFecha2, pTopN }
        const result = await axios.post(ArticuloRoutes.Obtener_Datos_Articulos, JSON.stringify(data), { headers: GetHeaderRequest(pToken) });
        return await GetResponseBody(result);
    },
    Obtener_Calificacion_Pedidos_Por_Articulo: async (pToken, pEmp_id, pSuc_id, pTopN, pArticulo_Id) => {
        const data = { pToken, pEmp_id, pSuc_id, pTopN, pArticulo_Id }
        const result = await axios.post(ArticuloRoutes.Obtener_Calificacion_Pedidos_Por_Articulo, JSON.stringify(data), { headers: GetHeaderRequest(pToken) });
        return await GetResponseBody(result);
    },
}


